// /* ==========================================================================
//    Gem collection page redesign — price range slider + Price/Availability
//    client-side filtering (our own, not the Search & Discovery app)
//    Added: 31 Aug 2026 / updated 01 Sep 2026
//    ========================================================================== */
// document.addEventListener('DOMContentLoaded', function () {
//   var priceWrapper = document.querySelector('[data-gem-price-filter]');
//   var availabilityCheckbox = document.getElementById('GemAvailableOnline');
//   var cards = document.querySelectorAll('.gem-product-grid .collection_product_block');

//   function applyGemFilters() {
//     if (!cards.length) return;
//     var priceMin = null;
//     var priceMax = null;
//     if (priceWrapper) {
//       priceMin = parseFloat(priceWrapper.querySelector('[data-price-min]').value);
//       priceMax = parseFloat(priceWrapper.querySelector('[data-price-max]').value);
//     }
//     var onlyAvailable = availabilityCheckbox ? availabilityCheckbox.checked : false;

//     cards.forEach(function (card) {
//       var price = parseFloat(card.dataset.gemPrice || '0') / 100;
//       var available = card.dataset.gemAvailable === 'true';
//       var visible = true;

//       if (priceWrapper && !isNaN(priceMin) && !isNaN(priceMax)) {
//         if (price < priceMin || price > priceMax) visible = false;
//       }
//       if (onlyAvailable && !available) visible = false;

//       card.classList.toggle('gem-hidden', !visible);
//     });
//   }

//   document.querySelectorAll('.price-range-slider').forEach(function (slider) {
//     var min = parseFloat(slider.dataset.min);
//     var max = parseFloat(slider.dataset.max);
//     var handleMin = slider.querySelector('.price-range-handle-min');
//     var handleMax = slider.querySelector('.price-range-handle-max');
//     var track = slider.querySelector('.price-range-track-active');
//     var wrapper = slider.closest('.price-range');
//     if (!wrapper) return;
//     var inputMin = wrapper.querySelector('[data-price-min]');
//     var inputMax = wrapper.querySelector('[data-price-max]');
//     var isOwnFilter = wrapper.hasAttribute('data-gem-price-filter');

//     function update() {
//       var minVal = parseFloat(handleMin.value);
//       var maxVal = parseFloat(handleMax.value);
//       if (minVal > maxVal) { minVal = maxVal; handleMin.value = minVal; }
//       track.style.left = ((minVal - min) / (max - min)) * 100 + '%';
//       track.style.right = 100 - (((maxVal - min) / (max - min)) * 100) + '%';
//       inputMin.value = minVal;
//       inputMax.value = maxVal;
//     }

//     handleMin.addEventListener('input', update);
//     handleMax.addEventListener('input', update);

//     if (isOwnFilter) {
//       handleMin.addEventListener('input', applyGemFilters);
//       handleMax.addEventListener('input', applyGemFilters);
//       inputMin.addEventListener('input', function () { handleMin.value = this.value; update(); applyGemFilters(); });
//       inputMax.addEventListener('input', function () { handleMax.value = this.value; update(); applyGemFilters(); });
//     } else {
//       var form = wrapper.closest('form');
//       function submitForm() { if (form) form.submit(); }
//       handleMin.addEventListener('change', submitForm);
//       handleMax.addEventListener('change', submitForm);
//     }

//     update();
//   });

//   if (availabilityCheckbox) {
//     availabilityCheckbox.addEventListener('change', applyGemFilters);
//   }
// });

// /* ==========================================================================
//    Gem collection page redesign — custom sort dropdown (matches blog-sort-dropdown)
//    Added: 01 Sep 2026
//    ========================================================================== */
// document.addEventListener('DOMContentLoaded', function () {
//   var dropdown = document.querySelector('.gem-sort-dropdown');
//   if (!dropdown) return;

//   var toggle = dropdown.querySelector('[data-sort-toggle]');
//   var menu = dropdown.querySelector('[data-sort-menu]');
//   var currentLabel = dropdown.querySelector('[data-sort-current]');
//   var nativeSelect = dropdown.querySelector('[data-sort-native]');
//   var options = dropdown.querySelectorAll('.gem-sort-option');

//   function closeMenu() {
//     menu.hidden = true;
//     dropdown.classList.remove('is-open');
//     toggle.setAttribute('aria-expanded', 'false');
//   }
//   function openMenu() {
//     menu.hidden = false;
//     dropdown.classList.add('is-open');
//     toggle.setAttribute('aria-expanded', 'true');
//   }

//   toggle.addEventListener('click', function (e) {
//     e.stopPropagation();
//     if (menu.hidden) { openMenu(); } else { closeMenu(); }
//   });

//   document.addEventListener('click', function (e) {
//     if (!dropdown.contains(e.target)) closeMenu();
//   });

//   options.forEach(function (option) {
//     option.addEventListener('click', function () {
//       options.forEach(function (o) { o.classList.remove('is-selected'); });
//       option.classList.add('is-selected');
//       if (currentLabel) currentLabel.textContent = option.textContent.trim();
//       closeMenu();
//       if (nativeSelect) {
//         nativeSelect.value = option.getAttribute('data-value');
//         nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     });
//   });
// });

// /* ==========================================================================
//    Gem collection page redesign — mobile "Add to cart" on product cards
//    Added: 01 Sep 2026
//    ========================================================================== */
// document.addEventListener('DOMContentLoaded', function () {
//   document.querySelectorAll('.gem-mobile-add-to-cart').forEach(function (btn) {
//     if (btn.disabled) return;
//     var originalText = btn.textContent;

//     btn.addEventListener('click', function (e) {
//       e.preventDefault();
//       var variantId = btn.getAttribute('data-variant-id');
//       if (!variantId) return;

//       btn.disabled = true;
//       btn.textContent = 'Adding...';

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: variantId, quantity: 1 })
//       })
//         .then(function (response) {
//           if (!response.ok) throw new Error('Add to cart failed');
//           return response.json();
//         })
//         .then(function () {
//           btn.textContent = 'Added!';
//           return fetch('/cart.js');
//         })
//         .then(function (response) { return response.json(); })
//         .then(function (cart) {
//           document.querySelectorAll('.cart-count').forEach(function (el) {
//             el.textContent = cart.item_count;
//             el.classList.toggle('hidden-count', cart.item_count === 0);
//           });
//         })
//         .catch(function () {
//           btn.textContent = 'Try again';
//         })
//         .finally(function () {
//           setTimeout(function () {
//             btn.disabled = false;
//             btn.textContent = originalText;
//           }, 1800);
//         });
//     });
//   });
// });

// /* ==========================================================================
//    Gem collection page redesign — position mobile filter drawer below the
//    site header instead of overlapping it (fixes header stacking conflict)
//    Added: 01 Sep 2026
//    ========================================================================== */
// document.addEventListener('DOMContentLoaded', function () {
//   var toggleInput = document.getElementById('GemFilterToggle');
//   var panel = document.querySelector('.gem-filter-drawer-panel');
//   if (!toggleInput || !panel) return;

//   function positionPanel() {
//     var header = document.querySelector('.header');
//     var offset = 0;
//     if (header) {
//       var rect = header.getBoundingClientRect();
//       offset = Math.max(0, rect.bottom);
//     }
//     panel.style.top = offset + 'px';
//   }

//   toggleInput.addEventListener('change', function () {
//     if (toggleInput.checked) {
//       positionPanel();
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = '';
//     }
//   });

//   window.addEventListener('resize', function () {
//     if (toggleInput.checked) positionPanel();
//   });
// });



(function () {
  var header = document.querySelector('.section-header .header');
  var searchIcon = header ? header.querySelector('.icon_list_search > .icon-search') : null;
  var inlineForm = header ? header.querySelector('.header-inline-search') : null;
  var inlineInput = inlineForm ? inlineForm.querySelector('[data-inline-search-input]') : null;
  var closeBtn = inlineForm ? inlineForm.querySelector('[data-action="close-inline-search"]') : null;
  if (!header || !searchIcon || !inlineForm) return;

  var desktopQuery = window.matchMedia('(min-width: 901px)');

  function openInline() {
    header.classList.add('search-inline-active');
    setTimeout(function () { inlineInput.focus(); }, 50);
  }

  function closeInline() {
    header.classList.remove('search-inline-active');
    inlineInput.blur();
  }

  searchIcon.addEventListener('click', function (e) {
    if (desktopQuery.matches) {
      e.preventDefault();
      e.stopPropagation();
      header.classList.contains('search-inline-active') ? closeInline() : openInline();
    }
    // below 1025px, default toggle-search behavior (the existing overlay) runs untouched
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeInline();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header.classList.contains('search-inline-active')) closeInline();
  });

  document.addEventListener('click', function (e) {
    if (header.classList.contains('search-inline-active') && !inlineForm.contains(e.target) && !searchIcon.contains(e.target)) {
      closeInline();
    }
  });

  desktopQuery.addEventListener('change', closeInline);
})();


/* ==========================================================================
   Gem collection page redesign — price range slider + Price/Availability
   client-side filtering (our own, not the Search & Discovery app)
   Added: 31 Aug 2026 / updated 01 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var priceWrapper = document.querySelector('[data-gem-price-filter]');
  var availabilityCheckbox = document.getElementById('GemAvailableOnline');
  var cards = document.querySelectorAll('.gem-product-grid .collection_product_block');

  function applyGemFilters() {
    if (!cards.length) return;
    var priceMin = null;
    var priceMax = null;
    if (priceWrapper) {
      priceMin = parseFloat(priceWrapper.querySelector('[data-price-min]').value);
      priceMax = parseFloat(priceWrapper.querySelector('[data-price-max]').value);
    }
    var onlyAvailable = availabilityCheckbox ? availabilityCheckbox.checked : false;

    cards.forEach(function (card) {
      var price = parseFloat(card.dataset.gemPrice || '0') / 100;
      var available = card.dataset.gemAvailable === 'true';
      var visible = true;

      if (priceWrapper && !isNaN(priceMin) && !isNaN(priceMax)) {
        if (price < priceMin || price > priceMax) visible = false;
      }
      if (onlyAvailable && !available) visible = false;

      card.classList.toggle('gem-hidden', !visible);
    });
  }

  document.querySelectorAll('.price-range-slider').forEach(function (slider) {
    var min = parseFloat(slider.dataset.min);
    var max = parseFloat(slider.dataset.max);
    var handleMin = slider.querySelector('.price-range-handle-min');
    var handleMax = slider.querySelector('.price-range-handle-max');
    var track = slider.querySelector('.price-range-track-active');
    var wrapper = slider.closest('.price-range');
    if (!wrapper) return;
    var inputMin = wrapper.querySelector('[data-price-min]');
    var inputMax = wrapper.querySelector('[data-price-max]');
    var isOwnFilter = wrapper.hasAttribute('data-gem-price-filter');

    function update() {
      var minVal = parseFloat(handleMin.value);
      var maxVal = parseFloat(handleMax.value);
      if (minVal > maxVal) { minVal = maxVal; handleMin.value = minVal; }
      track.style.left = ((minVal - min) / (max - min)) * 100 + '%';
      track.style.right = 100 - (((maxVal - min) / (max - min)) * 100) + '%';
      inputMin.value = minVal;
      inputMax.value = maxVal;
    }

    handleMin.addEventListener('input', update);
    handleMax.addEventListener('input', update);

    if (isOwnFilter) {
      handleMin.addEventListener('input', applyGemFilters);
      handleMax.addEventListener('input', applyGemFilters);
      inputMin.addEventListener('input', function () { handleMin.value = this.value; update(); applyGemFilters(); });
      inputMax.addEventListener('input', function () { handleMax.value = this.value; update(); applyGemFilters(); });
    } else {
      var form = wrapper.closest('form');
      function submitForm() { if (form) form.submit(); }
      handleMin.addEventListener('change', submitForm);
      handleMax.addEventListener('change', submitForm);
    }

    update();
  });

  if (availabilityCheckbox) {
    availabilityCheckbox.addEventListener('change', applyGemFilters);
  }
});

/* ==========================================================================
   Gem collection page redesign — custom sort dropdown (matches blog-sort-dropdown)
   Added: 01 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var dropdown = document.querySelector('.gem-sort-dropdown');
  if (!dropdown) return;

  var toggle = dropdown.querySelector('[data-sort-toggle]');
  var menu = dropdown.querySelector('[data-sort-menu]');
  var currentLabel = dropdown.querySelector('[data-sort-current]');
  var nativeSelect = dropdown.querySelector('[data-sort-native]');
  var options = dropdown.querySelectorAll('.gem-sort-option');

  function closeMenu() {
    menu.hidden = true;
    dropdown.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }
  function openMenu() {
    menu.hidden = false;
    dropdown.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    if (menu.hidden) { openMenu(); } else { closeMenu(); }
  });

  document.addEventListener('click', function (e) {
    if (!dropdown.contains(e.target)) closeMenu();
  });

  options.forEach(function (option) {
    option.addEventListener('click', function () {
      options.forEach(function (o) { o.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      if (currentLabel) currentLabel.textContent = option.textContent.trim();
      closeMenu();
      if (nativeSelect) {
        nativeSelect.value = option.getAttribute('data-value');
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
});

/* ==========================================================================
   Gem collection page redesign — mobile "Add to cart" on product cards
   Added: 01 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gem-mobile-add-to-cart').forEach(function (btn) {
    if (btn.disabled) return;
    var label = btn.querySelector('.gem-atc-label');
    if (!label) return;
    var originalText = label.textContent;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.disabled = true;
      label.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          label.textContent = 'Added!';
          return fetch('/cart.js');
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('.cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden-count', cart.item_count === 0);
          });
        })
        .catch(function () {
          label.textContent = 'Try again';
        })
        .finally(function () {
          setTimeout(function () {
            btn.disabled = false;
            label.textContent = originalText;
          }, 1800);
        });
    });
  });
});

/* ==========================================================================
   Gem collection page redesign — position mobile filter drawer below the
   site header instead of overlapping it (fixes header stacking conflict)
   Added: 01 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var toggleInput = document.getElementById('GemFilterToggle');
  var panel = document.querySelector('.gem-filter-drawer-panel');
  if (!toggleInput || !panel) return;

  function positionPanel() {
    var header = document.querySelector('.header');
    var offset = 0;
    if (header) {
      var rect = header.getBoundingClientRect();
      offset = Math.max(0, rect.bottom);
    }
    panel.style.top = offset + 'px';
  }

  toggleInput.addEventListener('change', function () {
    if (toggleInput.checked) {
      positionPanel();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  });

  window.addEventListener('resize', function () {
    if (toggleInput.checked) positionPanel();
  });
});

/* ==========================================================================
   Gem product page redesign — keep the sticky-summary "Qty" display in
   sync with the real quantity input (display only, doesn't touch the
   actual add-to-cart logic)
   Added: 02 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var qtyDisplay = document.querySelector('[data-gem-summary-qty]');
  var qtyInput = document.querySelector('.gem-product-info input[name="quantity"]');
  if (!qtyDisplay || !qtyInput) return;
 
  function syncQty() {
    qtyDisplay.textContent = qtyInput.value || '1';
  }
  qtyInput.addEventListener('change', syncQty);
  qtyInput.addEventListener('input', syncQty);
  var qtyObserver = new MutationObserver(syncQty);
  qtyObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
});
/* ==========================================================================
   Gem product page redesign — "+N more" gallery tile
   The lightbox itself is NOT initialized here — the theme already wires
   up Magnific Popup on any [data-mfp-src] element via
   Colors.Product.initImageZoom() in colors.js. The thumbnails already
   carry data-mfp-src, so they're already working correctly on their own.
   This just makes the "+more" tile open the same lightbox at the right
   image, by triggering a click on the first hidden real thumbnail
   instead of re-implementing gallery/index logic.
   Added: 03 Sep 2026
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gem-gallery-more').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var gallery = btn.closest('.gem-gallery');
      if (!gallery) return;
      var firstExtra = gallery.querySelector('.gem-thumb-extra a');
      if (firstExtra) firstExtra.click();
    });
  });
});

/* ==========================================================================
   Gem product page redesign — sticky summary bar visibility
   Shows the fixed bottom summary bar once the main quantity+add-to-cart
   row scrolls out of view, hides it again when scrolled back up to it.
   Added: 04 Sep 2026
   ========================================================================== */
document.addEventListener("DOMContentLoaded", function () {
  var summaryBar = document.querySelector(".gem-sticky-summary");
  var anchor = document.querySelector(".qty-add-to-cart-wrapper") || document.querySelector(".gem-notify-wrapper");
  if (!summaryBar || !anchor || typeof IntersectionObserver === "undefined") return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      summaryBar.classList.toggle("is-visible", !entry.isIntersecting);
    });
  }, { threshold: 0 });

  observer.observe(anchor);
});